import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueScrollTo from 'vue-scrollto'
import AOS from 'aos'
import 'aos/dist/aos.css'
import Buefy from 'buefy'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faEnvelope, faSmileWink } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

Vue.use(VueScrollTo, {
  container: 'body',
  duration: 1000,
  easing: 'ease',
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true,
})

library.add(faEnvelope, faSmileWink)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false
Vue.use(Buefy)

new Vue({
  created () {
    AOS.init({
      duration: 1000,
      delay: 200,
      once: true,
    })
  },
  router,
  render: (h) => h(App),
}).$mount('#app')
